import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";

const disclosureData = [
  { srNo: 1, financialYear: 'FY 2020-21', reportStatus: 'Conducted', remarks: 'nil' },
  { srNo: 2, financialYear: 'FY 2021-22', reportStatus: 'Conducted', remarks: 'nil' },
  { srNo: 3, financialYear: 'FY 2022-23', reportStatus: 'Conducted', remarks: 'nil' },
  { srNo: 4, financialYear: 'FY 2023-24', reportStatus: 'Conducted', remarks: 'nil' },
];

const Disclosures = () => {
  return (
    <div className="p-6 sm:p-8 bg-black text-white mb-14 min-h-screen">
      <h2 className="text-xl sm:text-5xl font-bold mb-6">Disclosures</h2>

      <Tabs defaultValue="compliance" className="w-full">
        <TabsList className="grid w-full md:w-[50%] lg:w-[35%] grid-cols-3 mb-8 bg-gray-900 p-1 rounded-xl">
          <TabsTrigger
            value="compliance"
            className="data-[state=active]:bg-[#57c0af] data-[state=active]:text-black text-gray-400 rounded-lg transition-all text-xs sm:text-sm"
          >
            Compliance Disclosure
          </TabsTrigger>
          <TabsTrigger
            value="ai"
            className="data-[state=active]:bg-[#57c0af] data-[state=active]:text-black text-gray-400 rounded-lg transition-all text-xs sm:text-sm"
          >
            AI Disclosure
          </TabsTrigger>
          <TabsTrigger
            value="payment"
            className="data-[state=active]:bg-[#57c0af] data-[state=active]:text-black text-gray-400 rounded-lg transition-all text-xs sm:text-sm"
          >
            Payment UPI
          </TabsTrigger>
        </TabsList>

        <TabsContent value="compliance">
          <p className="mb-6 text-sm sm:text-base leading-relaxed">
            Disclosure with respect to compliance with Annual Compliance Audit requirement under Regulation 19(3)
            of the Securities and Exchange Board of India (Investment Advisers) Regulations, 2013, for last and
            current financial years are as under:
          </p>

          {/* Unified Table View for all screen sizes */}
          <div className="mt-4 w-full overflow-x-auto">
            <div className="border border-[#57c0af] rounded-lg">
              <table className="min-w-full text-white">
                <thead className="border-b border-[#57c0af] bg-black">
                  <tr>
                    <th className="p-3 text-center border-r border-[#57c0af]">Sr. No</th>
                    <th className="p-3 text-center border-r border-[#57c0af]">Financial Year</th>
                    <th className="p-3 text-center border-r border-[#57c0af]">Compliance Audit Report</th>
                    <th className="p-3 text-center">Remarks, if any</th>
                  </tr>
                </thead>
                <tbody>
                  {disclosureData.map((item, index) => (
                    <tr
                      key={item.srNo}
                      className={`${index !== disclosureData.length - 1 ? 'border-b border-[#57c0af]' : ''
                        } `}
                    >
                      <td className="p-3 text-center border-r border-[#57c0af]">{item.srNo}</td>
                      <td className="p-3 text-center border-r border-[#57c0af]">{item.financialYear}</td>
                      <td className="p-3 text-center border-r border-[#57c0af]">{item.reportStatus}</td>
                      <td className="p-3 text-center">{item.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </TabsContent>

        <TabsContent value="ai">
          <div className="space-y-6 text-sm sm:text-base leading-relaxed">
            <h3 className="text-lg font-semibold text-[#57c0af]">Disclaimer - Use of Artificial Intelligence (‘AI’) Tools in IA Services</h3>
            <p>
              The Investment Adviser (IA) uses various Artificial Intelligence (AI) tools in providing investment advice to its clients as under:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>To gather data, information, and updates from different sources to conduct research across various asset classes and categories.</li>
              <li>To manage and organize data efficiently for improved research output.</li>
              <li>To enhance the quality, grammar, and readability of content.</li>
              <li>To quickly access summarized general data that may aid in better financial planning.</li>
            </ul>
          </div>
        </TabsContent>

        <TabsContent value="payment">
          <div className="space-y-8">
            {/* Full-width teal banner */}
            <div className="w-full bg-[#57c0af] rounded-2xl py-5 px-6 text-center">
              <p className="text-black font-bold text-xl sm:text-2xl tracking-wide">Payment Via UPI</p>
            </div>

            {/* Text left, QR right */}
            <div className="flex flex-col md:flex-row items-start md:items-center gap-10 md:gap-16">
              {/* Left: text */}
              <div className="flex-1 space-y-5 text-sm sm:text-base leading-relaxed">
                <p>We now have a validated UPI ID for all investor payments:</p>
                <p className="text-[#57c0af] font-semibold text-base sm:text-lg tracking-wide">
                  nuqiwealthindia.ia@validhdfc
                </p>
                <p>
                  You can also make payments by scanning our official QR code, which includes a white
                  thumbs-up icon inside a green triangle — a mark of authenticity.
                </p>
              </div>

              {/* Right: QR code */}
              <div className="flex flex-col items-center gap-3 w-full md:w-auto">
                <img
                  src="/QR.png"
                  alt="NUQI Wealth India UPI QR Code"
                  className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 object-contain"
                />
                <p className="text-[#57c0af] text-sm font-medium tracking-wide">
                  nuqiwealthindia.ia@validhdfc
                </p>
              </div>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Disclosures;